import { createSlice } from "@reduxjs/toolkit";
import { createInvoice, linkInvoice } from "./thunk"; // Import linkInvoice

const initialState = {
  // Invoice creation state
  createdInvoice: null,
  loading: null,
  error: null,
  linkInvoiceLoading: false,
  linkInvoiceError: null,
  linkInvoiceErrorCode: null,
};

const smartBillSlice = createSlice({
  name: "smartbill",
  initialState,
  reducers: {
    // Clear create invoice state
    clearCreateInvoiceState: (state) => {
      state.loading = false;
      state.createdInvoice = null;
      state.error = null;
    },
    
    // Clear link invoice state
    clearLinkInvoiceState: (state) => {
      state.linkInvoiceLoading = false;
      state.linkInvoiceError = null;
      state.linkInvoiceErrorCode = null;
    },
    
    // Clear all errors
    clearErrors: (state) => {
      state.error = null;
      state.linkInvoiceError = null;
    },
  },
  extraReducers: (builder) => {
    // Create Invoice cases
    builder
      .addCase(createInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.createdInvoice = action.payload;
        state.error = null;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to create invoice';
        state.createdInvoice = null;
      })
      
      // Link Invoice cases
      .addCase(linkInvoice.pending, (state) => {
        state.linkInvoiceLoading = true;
        state.linkInvoiceError = null;
      })
      .addCase(linkInvoice.fulfilled, (state, action) => {
        state.linkInvoiceError = null;
        state.linkInvoiceErrorCode = null;
        state.linkInvoiceLoading = false;

      })
      .addCase(linkInvoice.rejected, (state, action) => {
        state.linkInvoiceLoading = false;
        state.linkInvoiceError = action.payload?.message || 'Failed to link invoice';
        state.linkInvoiceErrorCode = action.payload?.code || null;
      });
  },
});

export const {
  clearCreateInvoiceState,
  clearLinkInvoiceState,
  clearErrors,
} = smartBillSlice.actions;

export default smartBillSlice.reducer;